    import {usePreachingContext} from "../../context/PreachingContext";
    import {useEffect, useState} from "react";
    import Form from "./Form";
    import SubmitButton from "../buttons/SubmitButton";
    import InputText from "../fields/InputText";
    import InputTextArea from "../fields/InputTextArea";
    import InputDate from "../fields/InputDate";
    import {updatePreaching} from "../../clients/PreachingClient";
    import sendSuccessAlert from "../../services/alertService";


    const EditPreachingForm = () => {

        const [church, setChurch] = useState('');
        const [theme, setTheme] = useState('');
        const [bibleVerse, setBibleVerse] = useState('');
        const [description, setDescription] = useState('');
        const [date, setDate] = useState(new Date());
        const [firstname, setFirstname] = useState('');
        const [lastname, setLastname] = useState('');
        const {redacted, setRedacted, refresh, selectedPreaching} = usePreachingContext();
        const [isAnimating, setAnimating] = useState(false);

        useEffect(() => {
            setChurch(selectedPreaching?.church || '')
            setTheme(selectedPreaching?.theme || '')
            setBibleVerse(selectedPreaching?.bible_verse || '')
            setDescription(selectedPreaching?.description || '')
            setDate(new Date(selectedPreaching?.preaching_date) || new Date())
            setFirstname(selectedPreaching?.preacher_firstname || '')
            setLastname(selectedPreaching?.preacher_lastname || '')
        }, [redacted,
            selectedPreaching
        ]);

        if (!redacted) return null;



        function disable() {
            return church.length === 0 ||
                theme.length === 0 ||
                bibleVerse.length === 0 ||
                firstname.length === 0 ||
                lastname.length === 0 ||
                description.length === 0
        }

        function clear() {
            setRedacted(false);
            setAnimating(false);
        }

        function close() {
            clear();
        }

        async function handleSubmit(e) {
            try {
                e.preventDefault();
                setAnimating(true);
                const id = selectedPreaching.id;
                await updatePreaching(id, church, theme, bibleVerse, firstname, lastname, description, date);
                clear();
                sendSuccessAlert('Проповедь успешно изменена')
                await refresh();
            } catch (error) {
                setAnimating(false);
                throw error;
            }
        }


        return <div>
            <Form
                title={`Редактирование проповеди`}
                onSubmit={handleSubmit}
                onClose={close}
            >
                <InputText
                    text={'Церковь'}
                    value={church}
                    placeholder={'Укажите церковь'}
                    onChange={e => setChurch(e.target.value)}
                />

                <InputText
                    text={'Основная тема'}
                    value={theme}
                    placeholder={'Укажите тему'}
                    onChange={e => setTheme(e.target.value)}
                />

                <InputText
                    text={'Основная стих'}
                    value={bibleVerse}
                    placeholder={'Укажите стих из библии'}
                    onChange={e => setBibleVerse(e.target.value)}
                />

                <InputDate
                    text={'Дата проповеди'}
                    value={date}
                    placeholder={'Укажите дату'}
                    onChange={e => setDate(e)}
                />

                <InputText
                    text={'Имя проповедника'}
                    value={firstname}
                    placeholder={'Укажите имя'}
                    onChange={e => setFirstname(e.target.value)}
                />

                <InputText
                    text={'Фамилия проповедника'}
                    value={lastname}
                    placeholder={'Укажите фамилию'}
                    onChange={e => setLastname(e.target.value)}
                />

                <InputTextArea
                    text={'Тезисы'}
                    value={description}
                    placeholder={'Укажите тезисы'}
                    onChange={e => setDescription(e)}
                />

                <SubmitButton
                    isAnimating={isAnimating}
                    disabled={disable()}
                    text={'✅ Отредактировать проповедь'}
                />

            </Form>
        </div>
    };

    export default EditPreachingForm;